import { service , service_Skin} from '../../service';

const state = {
  currentSkin:
    process.env.LAYOUT && process.env.LAYOUT.NAME ? process.env.LAYOUT.NAME : 'fullWidth', // ['default', 'sideNav', 'fullWidth']
  VIDEO_HD: process.env.LAYOUT  ? process.env.LAYOUT.VIDEO_HD : true, // [false, true]
  navigation:
    process.env.LAYOUT && process.env.LAYOUT.NAVIGATION
      ? process.env.LAYOUT.NAVIGATION
      : 'hasCarousel', // ['hasCarousel', 'hasCategories', 'hasScroll']
  components: {
    searchInput:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.SEARCH_INPUT
        ? process.env.LAYOUT.COMPONENTS.SEARCH_INPUT
        : 'default', // ['default', 'rounded',rectangle]
    navBar:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.NAV_BAR
        ? process.env.LAYOUT.COMPONENTS.NAV_BAR
        : 'default', // ['default', 'reverse' ,'demo']
    header:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.HEADER
        ? process.env.LAYOUT.COMPONENTS.HEADER
        : 'default', // ['default', 'large']
    switchMode:process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.SWITCH_MODE
      ? process.env.LAYOUT.COMPONENTS.SWITCH_MODE:false,
    mode:process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.MODE
      ? process.env.LAYOUT.COMPONENTS.MODE:'default', //['default','demo' , .... ]
    customHeader: process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.CUSTOM_HEADER
      ? process.env.LAYOUT.COMPONENTS.CUSTOM_HEADER
      : false,
    customMain: process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.CUSTOM_MAIN
      ? process.env.LAYOUT.COMPONENTS.CUSTOM_MAIN
      : false,
    customIcon: process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.CUSTOM_ICON
      ? process.env.LAYOUT.COMPONENTS.CUSTOM_ICON
      : false,
    reverseFooter: process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.REVERSE_FOOTER
      ? process.env.LAYOUT.COMPONENTS.REVERSE_FOOTER
      : false,


  },
  currentLogo: '',
  haveSocialMedia: process.env && process.env.SOCIALMEDIA
    ? process.env.SOCIALMEDIA
    : false,
  currentPrimaryColor: '',
  currentSecondaryColor: '',
  currentBackgroundColor: '',
  currentSkinPlayer: '',
  isSiteEmbed:false,
  modeDark:false,

};

const mutations = {
  SET_CURRENT_Skin(state, currentSkin) {
    state.currentSkin = currentSkin;
  },
  setCurrentPrimaryColor(state, primaryColor) {
    state.currentPrimaryColor = primaryColor;
  },
  setCurrentSecondaryColor(state, secondaryColor) {
    state.currentSecondaryColor = secondaryColor;
  },
  SET_CURRENT_Logo(state, currentLogo) {
    state.currentLogo = currentLogo;
  },
  SET_CURRENT_Skin_Player(state, currentSkinPlayer) {
    state.currentSkinPlayer = currentSkinPlayer;
  },
  SET_IS_SITE_EMBED(state, isSiteEmbed){
    state.isSiteEmbed = isSiteEmbed;
  },
  SET_MODE_DARK(state, is){
    state.modeDark = is;
  },
  setCurrentLayoutSkin(state, currentSkin){
    state.currentSkin = currentSkin;
  },
  setCurrentNavigationSkin(state, navigation){
    state.navigation = navigation;
  },
  setCurrentComponentsSkin(state, components){
    state.components = components;
  },
  SET_HAVE_SOCIAL_MEDIA(state, SocialMedia){
    state.haveSocialMedia = SocialMedia;

  },


};

const actions = {
  setHaveSocialMedia({ commit },SocialMedia){
    commit('SET_HAVE_SOCIAL_MEDIA',SocialMedia)
  },
  setIsSiteEmbed({ commit },isSiteEmbed){
    commit('SET_IS_SITE_EMBED',isSiteEmbed)
  },
  setmodeDark({ commit },modeDark){
    commit('SET_MODE_DARK',modeDark)
  },
  setCurrentSkin({ commit }, currentSkin) {
    commit('SET_CURRENT_Skin', currentSkin);
  },
  setCurrentLogo({ commit }, currentLogo) {
    commit('SET_CURRENT_Logo', currentLogo);
  },
  setCurrentSkinPlayer({ commit }, currentSkinPlayer) {
    commit('SET_CURRENT_Skin_Player', currentSkinPlayer);
  },
  async fetchCurrentSkin({ commit }) {
    /*const { data } = await service.getCurrentSkin({
      id: 139,
    });
    const currentSkin = data.data.value;
    commit('SET_CURRENT_Skin', currentSkin);*/
  },
  async fetchTemplateOptions({ commit }, obj) {

    const { data } = await  new Promise((resolve,reject)=>{
       service_Skin(obj).api.optionsGetOptionByIdDetail(obj.id,{type:obj.type}).then((response)=>{
           resolve(response)
           let options = response.data;
           let objectColors = JSON.parse(options.colors);
           let objectLayout = null;
           objectLayout = options.layout && options.layout !== "" ? JSON.parse(options.layout) : null ;
           commit('setCurrentPrimaryColor', objectColors.primary_color);
           commit('setCurrentSecondaryColor', objectColors.secondary_color);
           commit('setCurrentBackgroundColor', objectColors.background_color);
           commit('SET_CURRENT_Logo', options.logo);
           commit('SET_CURRENT_Skin_Player', options.skin_player);
           if(objectLayout){
             commit('setCurrentLayoutSkin', objectLayout.name);
             commit('setCurrentNavigationSkin', objectLayout.navigation);
             commit('setCurrentComponentsSkin', objectLayout.components);
           }
           (error)=>{
               console.log('error',error)
           }
    }).catch(error=>{
      console.log('error',error)
    });
    })

  }
};

const getters = {
  getHaveSocialMedia: state => state.haveSocialMedia,
  getIsSiteEmbed: state => state.isSiteEmbed,
  getCurrentSkin: state => state.currentSkin,
  getNavigation: state => state.navigation,
  isFullWidth: state => state.currentSkin === 'fullWidth',
  isSideNav: state => state.currentSkin === 'sideNav',
  hasCarousel: state => state.navigation === 'hasCarousel',
  hasCategories: state => state.navigation === 'hasCategories',
  hasScroll: state => state.navigation === 'hasScroll',
  getIsVideoHd: state => state.VIDEO_HD,
  getComponentStyle: state => state.components,
  getCurrentPrimaryColor: state => state.currentPrimaryColor,
  getCurrentSecondaryColor: state => state.currentSecondaryColor,
  getCurrentBackgroundColor: state => state.currentBackgroundColor,
  getCurrentLogo: state => state.currentLogo,
  getCurrentSkinPlayer: state => state.currentSkinPlayer,
  getmodeDark: state => state.modeDark,

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/layouts.js